__turbopack_context__.v({
  "criticalIcon": "message-box-module-scss-module__h6JC-G__criticalIcon",
  "informativeIcon": "message-box-module-scss-module__h6JC-G__informativeIcon",
  "successIcon": "message-box-module-scss-module__h6JC-G__successIcon",
  "u-animation-bounce": "message-box-module-scss-module__h6JC-G__u-animation-bounce",
  "warningIcon": "message-box-module-scss-module__h6JC-G__warningIcon",
});
